export function formatTime(s) {
  s = Math.floor(s);
  const m = Math.floor(s / 60), sec = s % 60;
  return m + ':' + sec.toString().padStart(2, '0');
}
